import React from 'react'
import PropTypes from 'prop-types'
import { Box, Button} from '@material-ui/core';
import { SUBSCRIBER_NETWORK_TYPE_DEFAULT1, SUBSCRIBER_NETWORK_TYPE_DEFAULT2, SUBSCRIBER_NETWORK_TYPE_PRIMARY } from '../../constants/commons';

class SubscriberTabComponent extends React.Component {
  static propTypes = {
    screenWidth: PropTypes.number,
    primaryNetwork: PropTypes.object,
    defaultNetwork1: PropTypes.object,
    defaultNetwork2: PropTypes.object,
    subscriber: PropTypes.object,
    setSelectedNetwork: PropTypes.func
  }

  constructor (props) {
    super(props)

    this.state = {
      selectedNetworkType: SUBSCRIBER_NETWORK_TYPE_PRIMARY,
      primaryNetwork: null,
      defaultNetwork1: null,
      defaultNetwork2: null
    }
  }

  selectedNetwork = (networkType, network, networkId) => {
    this.setState({ selectedNetworkType: networkType })
    this.props.setSelectedNetwork(networkType, network, networkId)
  }

  render () {
    const primaryNetwork = this.props.primaryNetwork && this.props.primaryNetwork.network
    const defaultNetwork1 = this.props.defaultNetwork1 && this.props.defaultNetwork1.network
    const defaultNetwork2 = this.props.defaultNetwork2 && this.props.defaultNetwork2.network
    const primaryNetworkId = this.props.primaryNetwork && this.props.primaryNetwork.network_entity_id
    const defaultNetwork1Id = this.props.defaultNetwork1 && this.props.defaultNetwork1.network_entity_id
    const defaultNetwork2Id = this.props.defaultNetwork2 && this.props.defaultNetwork2.network_entity_id
    return (
      <Box className="d-flex flex-wrap">
        <Button variant="contained" className={'labelBtn ' + (this.state.selectedNetworkType === SUBSCRIBER_NETWORK_TYPE_PRIMARY ? 'primaryActive' : '')} onClick={() => this.selectedNetwork(SUBSCRIBER_NETWORK_TYPE_PRIMARY, primaryNetwork, primaryNetworkId)}>{primaryNetwork}</Button>
        <Button variant="contained" className={'labelBtn ' + (this.state.selectedNetworkType === SUBSCRIBER_NETWORK_TYPE_DEFAULT1 ? 'defaultOneActive' : '')} onClick={() => this.selectedNetwork(SUBSCRIBER_NETWORK_TYPE_DEFAULT1, defaultNetwork1, defaultNetwork1Id)}>{defaultNetwork1}</Button>
        <Button variant="contained" className={'labelBtn ' + (this.state.selectedNetworkType === SUBSCRIBER_NETWORK_TYPE_DEFAULT2 ? 'defaultTwoActive' : '')} onClick={() => this.selectedNetwork(SUBSCRIBER_NETWORK_TYPE_DEFAULT2, defaultNetwork2, defaultNetwork2Id)}>{defaultNetwork2}</Button>
      </Box>
    )
  }
}

export default SubscriberTabComponent
